module.exports = __webpack_public_path__ + "static/img/2020123019390333.de9c9e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2020123019390333.jpg
// module id = ZB9f
// module chunks = 14